import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useHistory, Route, Redirect, useParams} from 'react-router-dom';

function ExhibitionEdit(){
    const [exhibitionEdit, setExhibitionEdit] = useState();
    const [museumList, setMuseumList] = useState([]);

    let {id} = useParams();
    
    const [name, setName] = useState('');
    const [museum, setMuseum] = useState('');
    const [genre, setGenre] = useState('');
    const [opening, setOpening] = useState('');
    const [closing, setClosing] = useState('');
    const [openingday, setOpeningday] = useState('');
    const [closingday, setClosingday] = useState('');
    const [tickets, setTickets] = useState('');
    const [website, setWebsite] = useState('');
    const [image, setImage] = useState('');
    const [image_copyright, setImage_copyright] = useState('');
    const [isFreeAdmission, setIsFreeAdmission] = useState('');
    const [isRecommendation, setIsRecommendation] = useState('');

    const history = useHistory();


    useEffect(()=>{
        getMuseumList()
        getExhibitionEdit()
    },[])

    function getMuseumList(){
        axios.get('/api/museum_list/all')
        .then(museumListFromMongo=>{
            setMuseumList(museumListFromMongo.data)
        })
        .catch(error=>{
            console.log(error)
        })
    };

    function getExhibitionEdit(){
        axios.get(`/api/get_exhibition/${id}`)
        .then(exhibitonDataFromMongo=>{
            setExhibitionEdit(exhibitonDataFromMongo.data)
            const openingDayEdit = makingEditDate(exhibitonDataFromMongo.data.openingday);
            const closingDayEdit = makingEditDate(exhibitonDataFromMongo.data.closingday);
            setOpeningday(openingDayEdit);
            setClosingday(closingDayEdit)
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const museumOptions = museumList.map(museum =>{
        return(
            <option key={museum._id} value={museum._id}>
                {museum.name}
            </option>
        )
    })

    const genreList =['Contemporary art', 'Modern art', 'Classic art', 'Ancient art', 'Applied fine arts', 'Photograph']

    const genreOptions = genreList.map(genre =>{
        return(
            <option key={genre} value={genre}>
                {genre}
            </option>
        )
    })

    const freeAdmissionList =['Yes', 'No']

    const freeAdmissioOptions = freeAdmissionList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const recommedationList =['Yes', 'No']

    const recommedationOptions = recommedationList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const makingEditDate = function(dateData){
        let dateDataForEdit = new Date(dateData)
        const y = dateDataForEdit.getFullYear();
        const m = ('00'+ (dateDataForEdit.getMonth()+1)).slice(-2);
        const d = ('00' + dateDataForEdit.getDate()).slice(-2);
        const forEdit = `${y}-${m}-${d}`;
        return forEdit
    }

    
    function editHandleSubmit(event){
        event.preventDefault();
     
        axios.post('/api/exhibition_edit/'+ id, {
           name, museum, genre, openingday, closingday, tickets, website, image, image_copyright, isFreeAdmission, isRecommendation

        })
        .then(response=>{
            history.push('/exhibitions/current/all')
        })
        .catch(error=>{
            console.log(error)
        })
    }
    return(
        <div>
            {(exhibitionEdit)?<div>
            <h2>{exhibitionEdit.name}/{exhibitionEdit.museum.name}</h2>
            <form method='POST' onSubmit={editHandleSubmit}>
                <div className='admin_post_flex'>
                <label>Name:</label>
                <input type='text' id='name' name='name' placeholder={exhibitionEdit.name} value={name} onChange={e=>setName(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Museum:</label>
                <select id='museum' name='museum' placeholder={exhibitionEdit.museum} value={museum} onChange={e=>setMuseum(e.target.value)}>
                <option hidden value=''>
                    Select museum
                </option>
                {museumOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Genre:</label>
                <select id='genre' name='genre' value={genre} onChange={e=>setGenre(e.target.value)}>
                <option hidden value=''>
                    Select genre
                </option>
                {genreOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Opeing Day:</label>
                <input type='date' id='openingday' name='openingday' placeholder={exhibitionEdit.openingday} value={openingday} onChange={e=>setOpeningday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Closing Day:</label>
                <input type='date' id='closingday' name='closingday' placeholder={exhibitionEdit.closingday} value={closingday} onChange={e=>setClosingday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Tickets:</label>
                <input type='text' id='tickets' name='tickets' placeholder={exhibitionEdit.tickets} value={tickets} onChange={e=>setTickets(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Web-Site:</label>
                <input type='text' id='web-site' name='web-site' placeholder={exhibitionEdit.website} value={website} onChange={e=>setWebsite(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image Url:</label>
                <input type='text' id='image' name='image' placeholder={exhibitionEdit.image} value={image} onChange={e=>setImage(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image Copyright:</label>
                <input type='text' id='image-copyright' name='image-copyright' placeholder={exhibitionEdit.image_copyright} value={image_copyright} onChange={e=>setImage_copyright(e.target.value)}/>
                </div>


                <div className='admin_post_flex'>
                <label>Is Free Admission? :</label>
                <select id='isFreeAdmission' name='isFreeAdmission' value={isFreeAdmission} onChange={e=>setIsFreeAdmission(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {freeAdmissioOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Is Your Recommendation? :</label>
                <select id='isRecommendation' name='isRecommendation' value={isRecommendation} onChange={e=>setIsRecommendation(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {recommedationOptions}
                </select>
                </div>
  
                <input type='submit' value='Submit'/>
            </form>
            </div>:''}
        </div>
    )
}

export default ExhibitionEdit;